/**
* Nom : ptuTypeList.js
* Description : Ce fichier contient la définition de la page ptuTypeList 
*               Cette page affiche les éléments pour gérer les types de PTU
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 13 mars 2026
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'
import { RemoveIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { GotoPage } from 'package_ui_ihm/dist'
import { SelectFormSide } from 'package_ui_ihm/dist'
import { FileFormSide } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'
import { function_display_file } from 'package_ui_ihm/dist'


/**
* PtuTypeList : affiche la page qui contient les éléments pour gérer les types de PTUs
*               un formulaire permet de filtrer en fonction du produit 
*               pour afficher la liste de tout les types de PTUs associés
*               un lien permet d'afficher un formulaire pour créer un nouveau type de PTU
*               un lien permet de revenir sur la page qui liste tous les sous-ensemble
*               un lien permet d'aller sur la page qui liste tous types de cartes LEDs
*               un lien permet d'aller sur la page qui liste tous types de LEDs
*
* Type : page 
*
* Parametres : 
*  None
*/
function PtuTypeList() {

    // Define useState hooks
    const [products, setProducts] = useState([])
    const [productVersions, setProductVersions] = useState([{id: 1, name: '1'}])
    const [ptuTypeRoles, setPtuTypeRoles] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(0)
    const [selectedProductVersion, setSelectedProductVersion] = useState(0)
    const [selectedPtuTypeRole, setSelectedPtuTypeRole] = useState(0)
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState(false);
    const [productError, setProductError] = useState(false);
    const [productVersionError, setProductVersionError] = useState(false);
    const [ptuTypeRoleError, setPtuTypeRoleError] = useState(false);
    const [reference, setReference] = useState('');
    const [referenceError, setReferenceError] = useState(false);
    const [isDataLoading, setDataLoading] = useState(false)
    const [isCreation, setCreation] = useState(false)
    const [ptuTypes, setPtuTypes] = useState([])
    const [statusPtuType, setStatusPtuType] = useState(null)
    const [ledCardTypes, setLedCardTypes] = useState([])
    const [selectedLedCardType1, setSelectedLedCardType1] = useState(0);
    const [selectedLedCardType2, setSelectedLedCardType2] = useState(0);
    const [selectedLedCardType3, setSelectedLedCardType3] = useState(0);
    const [selectedLedCardType4, setSelectedLedCardType4] = useState(0);
    const [ledCardType1Error, setLedCardType1Error] = useState(false);
    const [ledCardType2Error, setLedCardType2Error] = useState(false);
    const [ledCardType3Error, setLedCardType3Error] = useState(false);
    const [ledCardType4Error, setLedCardType4Error] = useState(false);
    const [numberLedCardType1, setNumberLedCardType1] = useState(0);
    const [numberLedCardType2, setNumberLedCardType2] = useState(0);
    const [numberLedCardType3, setNumberLedCardType3] = useState(0);
    const [numberLedCardType4, setNumberLedCardType4] = useState(0);
    const [numberLedCardType1Error, setNumberLedCardType1Error] = useState(false);
    const [numberLedCardType2Error, setNumberLedCardType2Error] = useState(false);
    const [numberLedCardType3Error, setNumberLedCardType3Error] = useState(false);
    const [numberLedCardType4Error, setNumberLedCardType4Error] = useState(false);
    const [ledCardTypeNumberMax, setLedCardTypeNumberMax] = useState(1)
    const [ledCardTypeNumber, setLedCardTypeNumber] = useState(1)
    const [transferFunction, setTransferFunction] = useState("");
    const [transferFunctionError, setTransferFunctionError] = useState(false);


    // Define useContext hooks
    const { authStatus, authToken, currentUser } = useAuth();
    const { path } = useApi();


    // Define useBlocker hooks
    const shouldBlock = isCreation;
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(reference, product_id, file, transfer_function, product_version, ptu_type_role_id) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("reference", reference);
        form_data.append("product_id", product_id);
        form_data.append("configuration_file", file, file.name);
        form_data.append("transfer_function", transfer_function);
        form_data.append("product_version", product_version);
        form_data.append("ptu_type_role_id", ptu_type_role_id);
        // Create ptu type
        const response = await fetch(path + "/api/eq-ptty/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        );
        setStatusPtuType(response["status"])
        let resJon = await response.json()
        let ptu_type_id = resJon.id
        if(response["status"] === 201){
            // Reset du formulaire
            setCreation(false)
            setReference('')
            setFile(null)
            setSelectedLedCardType1(0)
            setSelectedLedCardType2(0)
            setSelectedLedCardType3(0)
            setSelectedLedCardType4(0)
            setNumberLedCardType1(0)
            setNumberLedCardType2(0)
            setNumberLedCardType3(0)
            setNumberLedCardType4(0)
            setTransferFunction('')
            setSelectedPtuTypeRole(0)
            // Creation des liens ptu type et led card type 
            let selectedLedCardTypeInfos = [
                [selectedLedCardType1, numberLedCardType1], 
                [selectedLedCardType2, numberLedCardType2],
                [selectedLedCardType3, numberLedCardType3],
                [selectedLedCardType4, numberLedCardType4],
            ]
            for(let selectedLedCardTypeInfo of selectedLedCardTypeInfos)
            {
                if(selectedLedCardTypeInfo[0] !== 0)
                {
                    let form_data_link = new FormData();
                    form_data_link.append("PTU_type_id", ptu_type_id);
                    form_data_link.append("led_card_type_id", selectedLedCardTypeInfo[0]);
                    form_data_link.append("led_card_number", selectedLedCardTypeInfo[1]);
                    await fetch(path + "/api/eq-lpct/", 
                        {
                            method: 'POST',
                            credentials: 'include',
                            mode: 'cors',
                            headers: {
                                accept: 'application/json',
                                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                                Authorization: token,
                            },
                            body: form_data_link
                        }
                    );
                }
            }
            // Update ptuType list
            retrievePtuTypes()
        }
    }

    const handleClick = (event) => {
        event.preventDefault();
        setCreation(true)
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Check of data for PTU type
        if(reference === ''){
            setReferenceError(true)
        }
        else
        {   
            setReferenceError(false)
        }
        if(selectedProduct === 0 || selectedProduct === '0'){
            setProductError(true)
        }
        else
        {   
            setProductError(false)
        }
        if(selectedProductVersion === 0 || selectedProductVersion === '0'){
            setProductVersionError(true)
        }
        else
        {   
            setProductVersionError(false)
        }
        if(file === null || file === ''){
            setFileError(true)
        }
        else
        {   
            setFileError(false)
        }
        if(selectedLedCardType1 === 0 || selectedLedCardType1 === '0'){
            setLedCardType1Error(true)
        }
        else
        {   
            setLedCardType1Error(false)
        }
        if(numberLedCardType1 <= 0){
            setNumberLedCardType1Error(true)
        }
        else
        {   
            setNumberLedCardType1Error(false)
        }
        if((selectedLedCardType2 === 0 || selectedLedCardType2 === '0') && (numberLedCardType2 > 0)){
            setLedCardType2Error(true)
        }
        else
        {   
            setLedCardType2Error(false)
        }
        if((selectedLedCardType2 > 0) && (numberLedCardType2 <= 0)){
            setNumberLedCardType2Error(true)
        }
        else
        {   
            setNumberLedCardType2Error(false)
        }
        if((selectedLedCardType3 === 0 || selectedLedCardType3 === '0') && (numberLedCardType3 > 0)){
            setLedCardType3Error(true)
        }
        else
        {   
            setLedCardType3Error(false)
        }
        if((selectedLedCardType3 > 0) && (numberLedCardType3 <= 0)){
            setNumberLedCardType3Error(true)
        }
        else
        {   
            setNumberLedCardType3Error(false)
        }
        if((selectedLedCardType4 === 0 || selectedLedCardType4 === '0') && (numberLedCardType4 > 0)){
            setLedCardType4Error(true)
        }
        else
        {   
            setLedCardType4Error(false)
        }
        if((selectedLedCardType4 > 0) && (numberLedCardType4 <= 0)){
            setNumberLedCardType4Error(true)
        }
        else
        {   
            setNumberLedCardType4Error(false)
        }
        if(transferFunction === ""){
            setTransferFunctionError(true)
        }
        else
        {   
            setTransferFunctionError(false)
        }
        if(referenceError === false && productError === false && productVersionError === false && fileError === false && ledCardType1Error === false && numberLedCardType1Error === false && transferFunctionError === false){
            sendData(reference, selectedProduct, file, transferFunction, productVersions.find(version => version.id === Number(selectedProductVersion)).name, selectedPtuTypeRole)
        }
    };

    const handleReset = (event) => {
        event.preventDefault();
        setCreation(false)
        setReference('')
        setFile(null)
        setTransferFunction('')
        setSelectedLedCardType1(0)
        setSelectedLedCardType2(0)
        setSelectedLedCardType3(0)
        setSelectedLedCardType4(0)
        setNumberLedCardType1(0)
        setNumberLedCardType2(0)
        setNumberLedCardType3(0)
        setNumberLedCardType4(0)
        setSelectedPtuTypeRole(0)
        setReferenceError(false)
        setFileError(false)
        setTransferFunctionError(false)
        setPtuTypeRoleError(false)
    };

    function updateListToProduct() {
        setLedCardTypeNumber(1)
        if(Number(selectedProduct) === 1){
            // Sous-ensemble Boxitunnel
            setLedCardTypeNumberMax(4)
        }
        else if(Number(selectedProduct) === 2){
            // Sous-ensemble BoxiLab
            setLedCardTypeNumberMax(2)
        }
        else if(Number(selectedProduct) === 3){
            // Sous-ensemble Boxistick
            setLedCardTypeNumberMax(1)
        }
        else if(Number(selectedProduct) === 4){
            // Sous-ensemble Boxiclean
            setLedCardTypeNumberMax(2)
        } else {
            setLedCardTypeNumberMax(1)
        }
    }

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resProduct, resPtuTypeRole, resLedCardType] = await Promise.all([
            // Products
            fetch(path + "/api/eq-prct/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptu Type Roles
            fetch(path + "/api/eq-pttr/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Led Card Types
            fetch(path + "/api/eq-lcty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataProduct, dataPtuTypeRole, dataLedCardType] = await Promise.all([
            resProduct.json(),
            resPtuTypeRole.json(),
            resLedCardType.json(),
        ])
        // Set variables
        setProducts(dataProduct["results"])
        setPtuTypeRoles(dataPtuTypeRole["results"])
        setLedCardTypes(dataLedCardType["results"])
    }

    async function retrievePtuTypes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve ptu_types
        const urlPtuType = path + "/api/eq-ptty/?product_id=" + selectedProduct + "&product_version=" + productVersions.find(version => version.id === Number(selectedProductVersion)).name
        const resPtuType = await fetch(urlPtuType, 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataPtuType = await resPtuType.json();
        setPtuTypes(dataPtuType["results"])
    }

    function handleFile (event) {
        const file = event.target.files[0];
        setFile(file);
    };

    const displayDocument = (event, url) => {
        event.preventDefault();
        window.open(url, "_blank", "noopener,noreferrer")
    };

    const addLedCardType = (event) => {
        event.preventDefault();
        setLedCardTypeNumber(ledCardTypeNumber + 1)
    };

    const removeLedCardType = (event) => {
        event.preventDefault();
        setLedCardTypeNumber(ledCardTypeNumber - 1)
    };

    function computeLightingSurface (ptuType) {
        var lighting_surface = 0
        if(ptuType['link_ptu_type_led_card_types'] && ptuType['link_ptu_type_led_card_types'].length > 0){
            for(var link_ptu_type_led_card_type of ptuType['link_ptu_type_led_card_types'])
                {
                    lighting_surface = lighting_surface + link_ptu_type_led_card_type['led_card_number'] * link_ptu_type_led_card_type['led_card_type']['pcb_surface']
                } 
        } 
        return lighting_surface
    };

    async function retrieveProductVersions() {
        // Token
        const token = "Bearer " + authToken
        // Products versions
        if(Number(selectedProduct) !== 0)
        {
            const resProductVersion = await fetch(path + "/api/eq-prve/?product_id=" + selectedProduct, 
                {
                    method: 'GET',
                    credentials: 'include',
                    mode: 'cors',
                    headers: {
                        accept: 'application/json',
                        Authorization: token,
                    },
                }
            );
            const dataProductVersion = await resProductVersion.json();
            setProductVersions(dataProductVersion["results"])
        } 
        // Dataloading
        setDataLoading(false)
    }
    

    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setSelectedProductVersion(0)
        if(Number(selectedProduct) > 0)
        {
            retrieveProductVersions()
        }
        else
        {
            setDataLoading(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProduct])
    
    useEffect(() => {
        if(Number(selectedProductVersion) > 0)
        {
            updateListToProduct()
            retrievePtuTypes()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProductVersion]);

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
        if (shouldBlock === true) {
            // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
            e.preventDefault();
            e.returnValue = "";
            // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
            return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
        }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        <div>
                            <h1>Types de PTUs</h1>
                            {/*Lien de retour*/}
                            <div className={(screenWidth > 650) ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top'}>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <BackPage path={'/equipments/subset'}>Retour aux sous-ensembles</BackPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledCard'}>Cartes LEDs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledCardType'}>Types de cartes LEDs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledType'}>Types de LEDs</GotoPage>
                                </div>
                            </div>
                            {/*Choix du produit*/}
                            <form className='grid-1-1-1-1'>
                                {/*<h3>Choisir le produit</h3>*/}
                                <div/>
                                <SelectFormSide error={productError} labelText='Choisir le produit' choices={products.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedProduct} setSelectedItem={setSelectedProduct}/>
                                <SelectFormSide error={productVersionError} labelText='Choisir la version du produit' choices={productVersions.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedProductVersion} setSelectedItem={setSelectedProductVersion}/>
                            </form>
                            {/*Message d'erreur*/}
                            {(statusPtuType !== null && statusPtuType !== 201 && referenceError === false) ? (
                                <p className='form-error'>Le type de PTU existe déjà ou n'a pas pu être enregistré !</p>
                            ) : (
                                <p/>
                            )} 
                            {/*Liste et formulaire*/}
                            <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                                <div>
                                    {(selectedProduct > 0 && selectedProductVersion > 0) ? (
                                        /*New*/
                                        (currentUser["role_name"] !== "AT_RESEARCH") ? (
                                            <div className='flex-column'>
                                                <div className='link' onClick={handleClick}>
                                                    <img src={AddIcon} alt='add_item_icon' className='link-img' />
                                                    <div className='link-text'>Type de PTU</div>
                                                </div>
                                                {(isCreation === true) ? (
                                                    <div className='flex-rows'>
                                                        <h3>Nouveau type</h3>
                                                        <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                                                            <div className='flex-column'>
                                                                <InputFormSide error={referenceError} type="text" label="Référence" value={reference} setValue={setReference}/>
                                                                <p className='italic-text-note zero-margin-bottom'>Référence = M + liste (Nombre de carte LED d'une référence + '.' + référence de la carte LED)</p>
                                                                <p className='italic-text-note margin-bottom'>Exemple: M2.12x12/S3535-273_2.12x12/S3535-265</p>
                                                                <FileFormSide label="Ajouter un fichier" onChangeFunc={handleFile} currentValue={null}/>
                                                                <SelectFormSide error={ledCardType1Error} labelText={"Type de carte LED 1 (obligatoire)"} choices={ledCardTypes} choiceParam={'reference_AT'} selectedItem={selectedLedCardType1} setSelectedItem={setSelectedLedCardType1}/>
                                                                <InputFormSide error={numberLedCardType1Error} type="number" label="Nombre de carte LED 1" value={numberLedCardType1} setValue={setNumberLedCardType1}/>
                                                                {(ledCardTypeNumberMax >= 2 && ledCardTypeNumber >= 2) ? (
                                                                    <div>
                                                                        <SelectFormSide error={ledCardType2Error} labelText={"Type de carte LED 2"} choices={ledCardTypes} choiceParam={'reference_AT'} selectedItem={selectedLedCardType2} setSelectedItem={setSelectedLedCardType2}/>
                                                                        <InputFormSide error={numberLedCardType2Error} type="number" label="Nombre de carte LED 2" value={numberLedCardType2} setValue={setNumberLedCardType2}/>
                                                                    </div>
                                                                ) : (
                                                                    null
                                                                )}
                                                                {(ledCardTypeNumberMax >= 3 && ledCardTypeNumber >= 3) ? (
                                                                    <div>
                                                                        <SelectFormSide error={ledCardType3Error} labelText={"Type de carte LED 3"} choices={ledCardTypes} choiceParam={'reference_AT'} selectedItem={selectedLedCardType3} setSelectedItem={setSelectedLedCardType3}/>
                                                                        <InputFormSide error={numberLedCardType3Error} type="number" label="Nombre de carte LED 3" value={numberLedCardType3} setValue={setNumberLedCardType3}/>
                                                                    </div>
                                                                ) : (
                                                                    null
                                                                )}   
                                                                {(ledCardTypeNumberMax === 4 && ledCardTypeNumber === 4) ? (
                                                                    <div>
                                                                        <SelectFormSide error={ledCardType4Error} labelText={"Type de carte LED 4"} choices={ledCardTypes} choiceParam={'reference_AT'} selectedItem={selectedLedCardType4} setSelectedItem={setSelectedLedCardType4}/>
                                                                        <InputFormSide error={numberLedCardType4Error} type="number" label="Nombre de carte LED 4" value={numberLedCardType4} setValue={setNumberLedCardType4}/>
                                                                    </div>
                                                                ) : (
                                                                    null
                                                                )}  
                                                                <div className='grid-2-1-1-1 margin-bottom'>
                                                                    {(ledCardTypeNumberMax > 1) ? (
                                                                        <p className='item-text'>Type de Carte LED</p>
                                                                    ) : (
                                                                        null
                                                                    )}
                                                                    {(ledCardTypeNumber < ledCardTypeNumberMax) ? (
                                                                        <img onClick={addLedCardType} src={AddIcon} alt='add_item_icon' className='link-img' />
                                                                    ) : (
                                                                        null
                                                                    )}
                                                                    {(ledCardTypeNumber > 1) ? (
                                                                        <img onClick={removeLedCardType} src={RemoveIcon} alt='remove_item_icon' className='link-img' />
                                                                    ) : (
                                                                        null
                                                                    )}
                                                                </div>
                                                                <InputFormSide error={transferFunctionError} type="text" label="Fonction de transfert dP = f(d)" value={transferFunction} setValue={setTransferFunction}/>
                                                                <SelectFormSide error={ptuTypeRoleError} labelText={"Role du PTU"} choices={ptuTypeRoles} choiceParam={'name'} selectedItem={selectedPtuTypeRole} setSelectedItem={setSelectedPtuTypeRole}/>
                                                            </div>
                                                            <div className='flex-row form-center'>
                                                                <button type="reset" className='button'>Annuler</button>
                                                                <button type="submit" className='button'>Valider</button>
                                                            </div>
                                                        </form> 
                                                    </div>
                                                ) : (
                                                    <div></div>
                                                )}
                                            </div>
                                        ) : (
                                            null
                                        )
                                    ) : (
                                        <div/>
                                    )}
                                </div>
                                {(screenWidth > 650) ? null : <Divider/>}
                                {/*PTU type list*/}
                                <div className='scroll-list-rd'>
                                    {(selectedProduct > 0 && selectedProductVersion > 0) ? (
                                        (ptuTypes && ptuTypes.length !== 0) ? (
                                            ptuTypes.sort((a, b) => (a.reference > b.reference)?1:-1).map((ptuType) => (
                                                <Item key={ptuType['id']} id={ptuType['id']}>
                                                    <h3 className='item-text'>Référence: {ptuType['reference']}</h3> 
                                                    <p className='item-text'>
                                                        Type et nombre de carte LEDs : 
                                                        {
                                                            (ptuType['link_ptu_type_led_card_types'] && ptuType['link_ptu_type_led_card_types'].length > 0) ? (
                                                                ptuType['link_ptu_type_led_card_types'].map((link_ptu_type_led_card_type) => (" " + link_ptu_type_led_card_type['led_card_type']['reference_AT'] + " (" + link_ptu_type_led_card_type['led_card_number'] + "),"))
                                                            ) : (
                                                                null
                                                            )
                                                        }
                                                    </p>
                                                    {(ptuType['configuration_file'] !== null) ? (
                                                        <div className='item-text flex-row justify-start'>
                                                            Configuration : {function_display_file(ptuType['configuration_file'].split("/").at(-1))} 
                                                            {'  ( '}
                                                            <p className='link-doc clickable' onClick={(e) => displayDocument(e, ptuType['configuration_file'])}><strong>Visualiser</strong></p>
                                                            {' )'}
                                                        </div>
                                                    ) : (
                                                        null
                                                    )}
                                                    <p className='item-text'>
                                                        Surface d'éclairage : {computeLightingSurface(ptuType)} cm²
                                                    </p>
                                                    <p className='item-text'>
                                                        Fonction de transfert dPuissance = f(distance) : {ptuType['transfer_function']}
                                                    </p>
                                                    <p className='item-text'>
                                                        Role du PTU : {ptuType['ptu_type_role']['name']} 
                                                    </p>
                                                </Item>
                                            ))
                                        ) : (
                                            <p>Aucun type de PTU actuellement. Veuillez en créer un !</p>
                                        )
                                    ) : (
                                        <p>Aucun produit selectionné actuellement.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Container>
            </div>
        </div>
    );
}

export default PtuTypeList;
